<base-support-modal [title]="title" [btnOkClass]="'btn-warning'" [btnOkLabel]="'Установить'" (onOk)="ok()" >
	<div class="form-group">
		<label>Новый пароль</label>
		<input type="text" [(ngModel)]="password" class="form-control" required/>
	</div>
</base-support-modal>
